export default "__VITE_ASSET__dw0viW0Z__ 740w";